

//リッチテキストセクションの見出しでアンカーを付けるを選択したものにはliquidでjs-anchorクラスを付与している
//.js-ahchorを持つものにindex1,index2...と連番でidを付与する
function addAnchor(){
  var anchor = document.getElementsByClassName('js-anchor');
  
  var num = "index";
  for(var i = 0; i < anchor.length; i++){
    var anchorParent = anchor[i].parentNode;
    var anchorGParent = anchorParent.parentNode;
    var anchorGGParent = anchorGParent.parentNode;
    anchorGGParent.setAttribute("id",num+i);
  }
}
document.addEventListener('DOMContentLoaded', addAnchor);
